import { Navigate } from "react-router-dom-v5-compat";
import useAuth from "../hooks/useAuth";
import { canAccessVehicleAssignment } from "../utils/vehicleAssignmentAccess";

const VehicleAssignmentGuard = ({ children }) => {
  const { user } = useAuth();

  if (!canAccessVehicleAssignment(user?.companyid)) {
    return <Navigate to="/dashboard/assets" replace />;
  }

  return children;
};

export default VehicleAssignmentGuard;
